import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import DropdownBase from '../DropdownBase';
import DropdownMenuButton from './DropdownMenuButton';


export default class DropdownMenu extends React.PureComponent {
    static propTypes = {
        /** Id used to create the aria-controls pairing with the button and popup */
        id: PropTypes.string.isRequired,

        /** The trigger button label */
        label: PropTypes.node.isRequired,

        /** Shows a badge with this number to the right of the label text */
        badgeCount: PropTypes.number,

        /** Makes the trigger button disabled */
        isDisabled: PropTypes.bool,

        /** Contents of the popup */
        children: PropTypes.node,

        /** The text of the apply button; usually "Apply" or "Close" */
        applyButtonLabel: PropTypes.string,

        /** Content that is placed at the bottom left of the popup - directly
         * across from the apply button. */
        popupLeftActionElement: PropTypes.node,

        /** Callback fired when the user clicks the apply button */
        onApply: PropTypes.func,

        /** Callback fired when the user closes the popup. This can be for any
         * reason including: the user clicked outside the popup, tabbed away
         * from the dropdown menu or clicked the apply button */
        onClose: PropTypes.func,

        /** Ref that points to the trigger button */
        innerRef: PropTypes.shape({
            current: PropTypes.node
        }),

        /** highlights dropdown as being invalid (missing required selections etc) */
        isInvalid: PropTypes.bool,

        /** Displays the dropdown bottom actions section */
        showPopupActions: PropTypes.bool,

        /** Additional class applied to the outer container */
        className: PropTypes.string
    };

    static defaultProps = {
        isDisabled: false,
        onApply: undefined,
        onClose: undefined,
        applyButtonLabel: 'Apply',
        popupLeftActionElement: undefined,
        innerRef: undefined,
        badgeCount: undefined,
        showPopupActions: true
    };

    render() {
        const {
            children,
            badgeCount,
            label,
            className,
            innerRef,
            isInvalid,
            ...rest
        } = this.props;

        return (
            <DropdownBase
                size="md"
                className={cx('sarsa-dropdown-menu', className)}
                triggerButtonElement={
                    <DropdownMenuButton badgeCount={badgeCount} label={label} isInvalid={isInvalid} />
                }
                {...rest}>
                <div className="dropdown-menu-popup-content">
                    {children}
                </div>
            </DropdownBase>
        );
    }
}
